import { ITabButtonsProps } from '../models/ITabButtons'

import { BaseTabButtons } from './base/BaseTabButtons'

export const TabButtons = (props: ITabButtonsProps) => {
  return <BaseTabButtons {...props} />
}
